// Sidebar akun praktik bidan: Bidan (role 6) dan Kasir Klinik (role 7, tanpa menu rekam medis)
export default [
  {
    component: 'CNavItem',
    name: 'Beranda',
    to: '/klinik/beranda',
    icon: 'cil-home',
  },
  {
    component: 'CNavTitle',
    name: 'Pelayanan',
  },
  {
    component: 'CNavItem',
    name: 'Antrian Pasien',
    to: '/klinik/antrian',
    icon: 'cil-list',
  },
  {
    component: 'CNavItem',
    name: 'Data Pasien',
    to: '/klinik/pasien',
    icon: 'cil-people',
  },
  {
    component: 'CNavItem',
    name: 'Jadwal & Pengingat',
    to: '/klinik/jadwal',
    icon: 'cil-bell',
  },
  {
    component: 'CNavItem',
    name: 'Kasir',
    to: '/klinik/kasir',
    icon: 'cil-cart',
  },
  {
    component: 'CNavTitle',
    name: 'Apotek',
  },
  {
    component: 'CNavItem',
    name: 'Obat & Stok',
    to: '/klinik/apotek',
    icon: 'cil-medical-cross',
  },
  {
    component: 'CNavTitle',
    name: 'Praktik',
  },
  {
    component: 'CNavItem',
    name: 'Laporan',
    to: '/klinik/laporan',
    icon: 'cil-chart-pie',
  },
  {
    component: 'CNavItem',
    name: 'Layanan & Tarif',
    to: '/klinik/pengaturan',
    icon: 'cil-settings',
  },
]
